import { Price } from '@markant-platform/cartridge/model';

export const variantHasDefinedPrice = (variantPrice?: Price): boolean => {
  return !!variantPrice && !variantPrice.hasToBeRequested;
};
